<template>
  <div class="p-5 flex flex-col flex-grow gap-2">

    <div class="flex">
      <span class="p-1 w-[150px]">Einkaufsbereich:</span>
      <select v-model="purchaserId"
              class="outline-0 border border-bg-trader-input-border border-header p-1 w-full shadow-inner-2 text-gray-500">
        <option :value="0">Alle Einkaufsbereiche</option>
        <option v-for="purchaser in purchasers"
                :value="purchaser.id"
                :key="purchaser.id">
          {{ purchaser.teamIcon }} {{ purchaser.name }}
        </option>
      </select>
    </div>

    <!-- Neuer Select mit Mehrfachauswahl -->
    <div class="flex">
      <span class="p-1 h-[300px] w-[150px]">Weitere Auswahl:</span>
      <select v-model="selectedPurchasers" multiple
              class="outline-0 border border-bg-trader-input-border border-header gap-2 p-1 w-full shadow-inner-2 text-gray-500">
        <option class="p-1" v-for="purchaser in purchasers"
                :value="purchaser.id"
                :key="purchaser.id">
          {{ purchaser.teamIcon }} {{ purchaser.name }}
        </option>
      </select>
    </div>

    <div class="w-full flex gap-2">
      <button class="p-2 rounded flex-grow bg-trader-dark-gray" @click="selectPurchasers('food')">Food Einkaufsbereiche</button>
      <button class="p-2 rounded flex-grow bg-trader-dark-gray" @click="selectPurchasers('nonFood') ">NonFood Einkaufsbereiche</button>
    </div>


    <a @click="excelExport($event)" href="#"
       class="bg-trader-dark-gray p-2 h-10 w-full rounded hover:bg-trader-blue hover:text-white hover:dark:text-black">
      Abbildungsartikel Export
    </a>

    <TRProgress :progress="progress"></TRProgress>

    <p v-if="progress == 100">Der Abbildungsartikel Export ist fertig</p>

  </div>
</template>


<script setup lang="ts">
import {defineComponent, onMounted, ref} from 'vue'
import {query} from "@/graphql";
import TRProgress from "@/components/Base/v2/TRProgress.vue";
const projectId = ref<number>(0);
const magazineId = ref<number>(0);
const purchaserId = ref<number>(0);
const purchasers = ref([]);
const progress = ref<number>(0);
const isLoading = ref<boolean>(false);
const selectedPurchasers = ref<number[]>([0]);
const foodPurchasers = ref(false)
const nonFoodPurchasers = ref(false)

async function getPurchasers() {
  const [data, err] = await query.getPurchasers();
  purchasers.value = data;
  if (err) {
    console.error(err);
    return;
  }
}

function selectPurchasers(type) {
  if (type === 'food') {
    foodPurchasers.value = true;
    nonFoodPurchasers.value = false;
    selectedPurchasers.value = [
      69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79,
      83, 84,
      1727, 1728, 1729, 1730, 1731, 1732, 1733, 1734, 1735, 1736
    ];
  } else {
    foodPurchasers.value = false;
    nonFoodPurchasers.value = true;
    selectedPurchasers.value = [
        96, 97, 98,
        100, 101, 102, 103, 104, 105, 106, 107, 108, 109,
        1737, 1738
  ];
  }

}
function startFakeProgress() {
  const progressSteps40 = [
    { time: 0,    percent: 0 },
    { time: 4000, percent: 10 },
    { time: 8000, percent: 20 },
    { time: 12000, percent: 25 },
    { time: 16000, percent: 35 },
    { time: 20000, percent: 45 },
    { time: 24000, percent: 55 },
    { time: 28000, percent: 65 },
    { time: 32000, percent: 75 },
    { time: 36000, percent: 80 },
    { time: 38000, percent: 85 },
    { time: 40000, percent: 90 }
  ];
  const progressSteps10 = [
    { time: 0,     percent: 0 },
    { time: 1000,  percent: 10 },
    { time: 2000,  percent: 20 },
    { time: 3000,  percent: 25 },
    { time: 4000,  percent: 35 },
    { time: 5000,  percent: 45 },
    { time: 6000,  percent: 55 },
    { time: 7000,  percent: 65 },
    { time: 8000,  percent: 75 },
    { time: 9000,  percent: 80 },
    { time: 9500,  percent: 85 },
    { time: 10000, percent: 90 }
  ];
  const progressSteps5 = [
    { time: 0,     percent: 0 },
    { time: 500,   percent: 10 },
    { time: 1000,  percent: 20 },
    { time: 1500,  percent: 25 },
    { time: 2000,  percent: 35 },
    { time: 2500,  percent: 45 },
    { time: 3000,  percent: 55 },
    { time: 3500,  percent: 65 },
    { time: 4000,  percent: 75 },
    { time: 4500,  percent: 80 },
    { time: 4750,  percent: 85 },
    { time: 5000,  percent: 90 }
  ];
  const progressSteps70 =[
    { time: 0,     percent: 0 },
    { time: 7000,  percent: 10 },
    { time: 14000, percent: 20 },
    { time: 21000, percent: 25 },
    { time: 28000, percent: 35 },
    { time: 35000, percent: 45 },
    { time: 42000, percent: 55 },
    { time: 49000, percent: 65 },
    { time: 56000, percent: 75 },
    { time: 63000, percent: 80 },
    { time: 66500, percent: 85 },
    { time: 70000, percent: 90 }
  ]
  let choseProgress = [];
  if (foodPurchasers.value) {
    choseProgress = progressSteps70
  }else {
    choseProgress = progressSteps5
  }
  if (!isLoading.value) {
    return;
  }
  choseProgress.forEach(step => {
    setTimeout(() => {
      progress.value = step.percent;
    }, step.time);
  });
}

onMounted(async () => {
  await getPurchasers();

});
function excelExport(event) {
  isLoading.value = true;
  // Verhindert das Standardverhalten des Links (Navigation)
  event.preventDefault();
  if (selectedPurchasers.value.length === 0) {
    if (purchaserId.value !== 0) {
      selectedPurchasers.value =  [purchaserId]
    }
  }

  const url = `/api/v3/excel/selectedPurchasers/${selectedPurchasers.value.join(',')}`;
  // Öffnet die URL in einem neuen Tab
  fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Export fehlgeschlagen');
        }
        return response.blob();
      })
      .then(blob => {
        // Erstelle eine URL für den Blob
        const blobUrl = window.URL.createObjectURL(blob);
        // Erstelle einen Link und simuliere einen Klick
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = 'export.xlsx'; // Dateiname setzen
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(blobUrl);
        isLoading.value = false;
        progress.value = 100;
        // Hier weißt du, dass der Download fertig ist
      })
      .catch(error => {
        console.error(error);
        isLoading.value = false;
      });
  //window.open(url, '_blank');
  startFakeProgress();
}

</script>
